// extracted by mini-css-extract-plugin
module.exports = {"Partner":"_1-7-CR7pkD2d45i2zjKJfs","paragraph":"CmWYUatI5MdYETdrmYPMU","description":"_1kR3xMFJmLBjpH3h1wsano","image2":"_1jHq5CvqInud1X7G7-HAU5"};